import NoReviewsImage from 'src/shared/features/users/assets/empty/key.png'

import EmptyView from './empty-view'

const NoReviews = ({ firstName }: { firstName: string }) => {
  return (
    <EmptyView
      description={`${firstName}'s Zillow reviews will appear here once connected.`}
      image={<img src={NoReviewsImage} className="-translate-x-3 translate-y-10 scale-125 md:-translate-x-5" />}
      title={`${firstName} doesn't have any reviews yet.`}
    />
  )
}

export default NoReviews
